import { createAsyncThunk } from '@reduxjs/toolkit';
import { AppDispatch } from '@store/types';
import { DocumentCategories } from '@v2/components/imageHandling/types/types';
import { backendCall, createApiCall } from '@reducers/utils';

export const fetchDocumentCategories = createAsyncThunk<DocumentCategories['items'], void, { dispatch: AppDispatch }>(
	'imageHandlingV2/fetchDocumentCategories',
	async (_, { dispatch }) => {
		const categories = await dispatch(
			backendCall(createApiCall((api) => api.imageHandling.getDocumentCategories))
		);

		if (categories) {
			return categories.map((item: any) => ({
				name: item.name || item.Name,
				value: item.id || item.Id || item.value || item.name,
				title: item.title || item.Title || '',
			}));
		}

		throw new Error('Failed to fetch document categories');
	}
);